
















































import { Component, Vue } from "vue-property-decorator";
import axios from "@/api/AuthAPI/auth-request-api";
import { configuration } from "@/config/host.config";
import { ITelemetry } from "@/@types/servers/telemetry";

import CpuCard from "@/components/servers/CpuCard.vue";
import MemoryCard from "@/components/servers/MemoryCard.vue";
import StorageCard from "@/components/servers/StorageCard.vue";
import NetworkCard from "@/components/servers/NetworkCard.vue";
import TemperatureCard from "@/components/servers/TemperatureCard.vue";

@Component({
  components: {
    CpuCard,
    MemoryCard,
    StorageCard,
    NetworkCard,
    TemperatureCard,
  },
})
export default class AdministrationTelemetry extends Vue {
  telemetry: ITelemetry | null = null;
  loading = true;
  error = "";
  polling = false;
  private pollTimer: ReturnType<typeof setInterval> | null = null;

  async fetchTelemetry(): Promise<void> {
    try {
      this.loading = true;
      this.error = "";
      const { data } = await axios.get<ITelemetry>(configuration.telemetry);
      this.telemetry = data;
    } catch (err: any) {
      this.error = err?.message || "Unknown error";
    } finally {
      this.loading = false;
    }
  }

  startPolling(): void {
    this.stopPolling();
    this.polling = true;
    this.pollTimer = setInterval(() => {
      this.fetchTelemetry();
    }, 1000);
  }

  stopPolling(): void {
    this.polling = false;
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  }

  formatTimestamp(ts: string): string {
    try {
      const d = new Date(ts);
      return d.toLocaleTimeString();
    } catch {
      return ts;
    }
  }

  async mounted(): Promise<void> {
    await this.fetchTelemetry();
    this.startPolling();
  }

  beforeDestroy(): void {
    this.stopPolling();
  }
}
